module.exports = __webpack_public_path__ + "src/assets/img/m4.02dc23bf.jpg";